export const fragSamplerOverlay = `
precision mediump float;

uniform sampler2D uSampler0;
uniform sampler2D uSampler1;
varying vec2 outTexCoord;

void main ()
{
  vec4 bottomColor = texture2D(uSampler0, outTexCoord);
  vec4 topColor = texture2D(uSampler1, outTexCoord);

  float alphaBotToUse = 1.0 - topColor.a;

  // Scaling the alpha values (not just the rgb values) is what's causing a resulting alpha drop despite one of the layers being opaque.
  // vec4 endColour = (topColor * topColor.a) + (bottomColor * alphaBotToUse);

  // Consequently, we're only supposed to scale the colours for blending, but let the alphas stack, because "overlaying" is not he same as "blending".
  vec4 newBotColour = vec4(bottomColor.rgb * alphaBotToUse, bottomColor.a);
  vec4 newTopColour = vec4(topColor.rgb * topColor.a, topColor.a);

  gl_FragColor = newBotColour + newTopColour;
}
`;
